import React from 'react';
import { formatValueAsString } from '../../../../../utils/helpers';

interface ICohortDefinitionProps {
	title: string;
	minSize?: number;
	maxSize?: number;
	shipsNumber?: number;
	size?: number;
	sizeUnit?: string;
	age: number;
	isCohort?: boolean;
	maxAge?: number;
	minAge?: number;
}

const CohortDefinition: React.FC<ICohortDefinitionProps> = ({ ...props }) => {
	return (
		<div>
			<div className="text-msi-darkblue-color-400 font-bold text-lg mb-1">{props.title}</div>
			<div className="flex flex-row gap-8">
				<div className="text-msi-darkgrey-color text-sm">
					Size:{' '}
					<span className="font-semibold">
						{
							// if isCohort is true, show minSize and maxSize, otherwise just show size
							props.isCohort && props.shipsNumber && props.shipsNumber > 1
								? `${formatValueAsString(props.minSize, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} to
								${formatValueAsString(props.maxSize, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${props.sizeUnit}`
								: formatValueAsString(props.size, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' ' + props.sizeUnit
						}
					</span>
				</div>
				<div className="text-msi-darkgrey-color text-sm">
					Age:{' '}
					<span className="font-semibold">
						{
							// If isCohort is true, show age range, otherwise just show the age
							props.isCohort && props.shipsNumber && props.shipsNumber > 1
								? `${props.minAge} to ${props.maxAge} Years Old`
								: `${props.age} Years Old`
						}
					</span>
				</div>

				{props.isCohort && (
					<div className="text-msi-darkgrey-color text-sm">
						# Ships: <span className="font-semibold">{props.shipsNumber}</span>
					</div>
				)}
			</div>
		</div>
	);
};

export default CohortDefinition;
